export class CheckboxItem {
  public id: string;
  public name: string;
  public checked: boolean;
  public selectable?: boolean;
  public notes?: string[];
}
